const AmountCreditWidget = ({ label, amount }) => {
	return (
		<div className="d-flex justify-content-between align-items-center mb-2">
			<div className="fs-5 text-muted">{label}</div>
			<div className="fs-5 text-muted">{`₹ ${amount.toFixed(2)}`}</div>
		</div>
	);
};

export default AmountCreditWidget;
